var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4697 3.46967C18.7626 3.17678 19.2374 3.17678 19.5303 3.46967L22.5303 6.46967C22.8232 6.76256 22.8232 7.23744 22.5303 7.53033C22.2374 7.82322 21.7626 7.82322 21.4697 7.53033L19.75 5.81066V18.1893L21.4697 16.4697C21.7626 16.1768 22.2374 16.1768 22.5303 16.4697C22.8232 16.7626 22.8232 17.2374 22.5303 17.5303L19.5303 20.5303C19.2374 20.8232 18.7626 20.8232 18.4697 20.5303L15.4697 17.5303C15.1768 17.2374 15.1768 16.7626 15.4697 16.4697C15.7626 16.1768 16.2374 16.1768 16.5303 16.4697L18.25 18.1893V5.81066L16.5303 7.53033C16.2374 7.82322 15.7626 7.82322 15.4697 7.53033C15.1768 7.23744 15.1768 6.76256 15.4697 6.46967L18.4697 3.46967ZM1.25 6C1.25 5.58579 1.58579 5.25 2 5.25H6C6.41421 5.25 6.75 5.58579 6.75 6C6.75 6.41421 6.41421 6.75 6 6.75H2C1.58579 6.75 1.25 6.41421 1.25 6ZM1.25 10C1.25 9.58579 1.58579 9.25 2 9.25H8C8.41421 9.25 8.75 9.58579 8.75 10C8.75 10.4142 8.41421 10.75 8 10.75H2C1.58579 10.75 1.25 10.4142 1.25 10ZM1.25 14C1.25 13.5858 1.58579 13.25 2 13.25H10C10.4142 13.25 10.75 13.5858 10.75 14C10.75 14.4142 10.4142 14.75 10 14.75H2C1.58579 14.75 1.25 14.4142 1.25 14ZM1.25 18C1.25 17.5858 1.58579 17.25 2 17.25H12C12.4142 17.25 12.75 17.5858 12.75 18C12.75 18.4142 12.4142 18.75 12 18.75H2C1.58579 18.75 1.25 18.4142 1.25 18Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.3fa4045a9cb179c0b93c0e50f2bdd3a3.svg";
export { ForwardRef as ReactComponent };